import { useRecentPerps } from "@nitro-ape/shared/providers/settings-provider";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/perpetuals/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitlePerpetuals),
      },
    ],
  }),
  component: PerpetualsPage,
});

function PerpetualsPage() {
  const { recentPerps } = useRecentPerps();

  if (recentPerps.length > 0) {
    return (
      <Navigate to="/perpetuals/$coin" params={{ coin: recentPerps[0] }} />
    );
  } else {
    return <Navigate to="/perpetuals/$coin" params={{ coin: "BTC" }} />;
  }
}
